
import { Grid } from '@material-ui/core';
import {  GridColumns, GridRowData } from '@material-ui/data-grid';
import { useHistory, useLocation } from 'react-router-dom';
import { PilotsSummaryProps, Stats } from '../../../Interfaces/Interfaces';
import Table from '../../Table/Table';

const Pilots = (props: PilotsSummaryProps) => {
	const stats = props.pilots
	const history = useHistory();
	const locationState = useLocation().state

	const actionHandler = (id: number | string): void => {
		const pilotId = Object(stats).find((pilot: Stats) => pilot.id === id)?.id
		history.push(`Pilot/${pilotId}/Air`, locationState);
	}

	const headers:GridColumns= [
		{ field: 'playerName', headerName: 'Player Name', type: 'string', width: 200, headerAlign: 'left', align: 'left' },
		{ field: 'killsPlanes', headerName: 'Air Kills', type: 'number', width: 130, headerAlign: 'center', align: 'center' },
		{ field: 'killsShips', headerName: 'Naval Kills', type: 'number', width: 130, headerAlign: 'center', align: 'center' },
		{ field: 'killsGround', headerName: 'Ground Kills', type: 'number', width: 140, headerAlign: 'center', align: 'center' },
		{ field: 'teamkills', headerName: 'Team Kills', type: 'number', width: 140, headerAlign: 'center', align: 'center' },
		{ field: 'deaths', headerName: 'Deaths', type: 'number', width: 140, headerAlign: 'center', align: 'center' },
		{ field: 'crashes', headerName: 'Crashes', type: 'number', width: 140, headerAlign: 'center', align: 'center' },
		{ field: 'ejections', headerName: 'Ejections', type: 'number', width: 140, headerAlign: 'center', align: 'center' },
	];

	return (
		<Grid item xs={12}>
			<Table rows={stats ? stats as GridRowData: null} editTable={false} columns={headers} action={actionHandler} />
		</Grid>
	)
}
export default Pilots ;
